import { render, staticRenderFns } from "./MemberClassesAnnouncement.vue?vue&type=template&id=737c0e44&scoped=true&"
import script from "./MemberClassesAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MemberClassesAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./MemberClassesAnnouncement.vue?vue&type=style&index=0&id=737c0e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c0e44",
  null
  
)

export default component.exports